import { Switch } from '@billy/design-system'
import styled from '@emotion/styled'

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const Toggle = styled(Switch)`
  width: fit-content;
  margin: 0 10px;
`
